export const iconContainerWidth = '20px';
export const dataGap = '12px';
export const getTitleTextWidth = (afterSlotWidth?: number) =>
  `calc(100% - ${iconContainerWidth} - (2 * ${parseInt(dataGap)}px) - ${afterSlotWidth || 0}px)`;
